import React from "react";
import { DateTimeDisplay, getUsernameWithoutPrefix, Text } from "sprint-common-web";

import { ChangeValue } from "../AuditItem";

export const renderAuditInfo = (updatedBy: string, updatedDate: string): React.ReactNode => {
    return (
        <>
            <div style={{ display: "flex", justifyContent: "left", gap: 4 }}>
                <Text variant={"small"} styles={{ root: { fontWeight: 600 } }} value={`Updated by:`} />
                <Text variant={"smallPlus"} value={`${getUsernameWithoutPrefix(updatedBy)}`} />
            </div>
            <div style={{ display: "flex", justifyContent: "left", gap: 4 }}>
                <Text variant={"small"} styles={{ root: { fontWeight: 600 } }} value={`Updated date`} />
                <Text variant={"smallPlus"}>
                    <DateTimeDisplay date={updatedDate} />
                </Text>
            </div>
            <Text variant={"small"} styles={{ root: { fontWeight: 600, marginBottom: 10 } }} value={`Change:`} />
        </>
    );
};

export const renderSimpleChangeInfo = ({ from, to, label }: ChangeValue & { label: string }): React.ReactNode => {
    return (
        <div style={renderInfoStyles}>
            <Text value={label} variant="smallPlus" />
            <Text variant="smallPlus" nowrap={false} styles={{ root: { fontWeight: 600 } }}>
                {from} → {to}
            </Text>
        </div>
    );
};

export const renderDateChangeInfo = ({ from, to, label }: ChangeValue & { label: string }): React.ReactNode => {
    const fromDate = from ? <DateTimeDisplay date={from} /> : "-";
    const toDate = to ? <DateTimeDisplay date={to} /> : "-";

    return (
        <div style={renderInfoStyles}>
            <Text value={label} variant="smallPlus" />
            <Text variant="smallPlus" nowrap={false} styles={{ root: { fontWeight: 600 } }}>
                {fromDate} → {toDate}
            </Text>
        </div>
    );
};

const renderInfoStyles = { display: "flex", justifyContent: "left", gap: 4 };
